var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4229 1.07812H4.42285C3.6272 1.07812 2.86414 1.3942 2.30153 1.9568C1.73892 2.51941 1.42285 3.28248 1.42285 4.07812V34.0781C1.42285 34.8738 1.73892 35.6368 2.30153 36.1994C2.86414 36.7621 3.6272 37.0781 4.42285 37.0781H34.4229C35.2185 37.0781 35.9816 36.7621 36.5442 36.1994C37.1068 35.6368 37.4229 34.8738 37.4229 34.0781V4.07812C37.4229 3.28248 37.1068 2.51941 36.5442 1.9568C35.9816 1.3942 35.2185 1.07812 34.4229 1.07812Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4229 10.0781L9.42285 28.0781M27.4229 28.0781V20.0781M27.4229 15.0781V14.0781M15.4229 10.0781L21.4229 28.0781M11.4229 22.0781H19.4229",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory05);
export default __webpack_public_path__ + "static/media/category-05.3687d3e77cf88522bb9b3b416ce9497f.svg";
export { ForwardRef as ReactComponent };